

























import ThemeButton from '@/components/ThemeButton.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as env from '@/common/environment';

@Component({ components: { ThemeButton } })
export default class ACActions extends Vue {
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop({ default: 'x' }) readonly maxLimit!: string|number

  appName = env.get('appName')
}
